export default function tryParseJson(inputString) {
    if (inputString) {
        try {
            return JSON.parse(inputString)
        } catch (e) {
            return inputString
        }
    }
}
